import styled from '@emotion/styled';
import { Grid } from '@mui/material';

const GridContainer = styled(Grid)`
  height: 100%;
`;
export { GridContainer };
